import React, { useCallback, useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";
import "../Admin/admin.css";
import { endpoints } from "../_config";
import { get, post } from "../_services/apiService";
import { toast } from "react-toastify";

const STATUS_MAP = {
    Pending: 0,
    Accept: 1,
    Reject: 2,
};

const UserQuotation = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(5);

    const [quatationData, setQuatationData] = useState();
    const loginId = localStorage.getItem("loginId");
    const [quatationItemData, setQuatationItemData] = useState();
    const [productOrderData, setproductOrderData] = useState();

    const GetQuatation = useCallback(async () => {
        try {
            const response = await get(endpoints.GetQuatationByLoginId + `?pLoginId=${loginId}`)
            if (response.isSuccess === 200) {
                setQuatationData(response.data);
            } else {
                setQuatationData(null)
            }
        } catch (error) {
            setQuatationData(null)
        }
    }, [loginId]);

    useEffect(() => {
        GetQuatation();
    }, [GetQuatation]);


    const data = [
        {
            id: 1,
            image: "https://imageio.forbes.com/specials-images/imageserve/5d35eacaf1176b0008974b54/0x0.jpg?format=jpg&crop=4560,2565,x790,y784,safe&height=900&width=1600&fit=bounds",
            code: "#22323",
            name: "Car",
            displayName: "Car",
            description: "Here Are The Coolest New Cars For 2020",
            isDisplay: true,
            isActive: true,
        },
        {
            id: 2,
            image: "https://imageio.forbes.com/specials-images/imageserve/5d35eacaf1176b0008974b54/0x0.jpg?format=jpg&crop=4560,2565,x790,y784,safe&height=900&width=1600&fit=bounds",
            code: "#22323",
            name: "Bike",
            displayName: "Bike",
            description: "New Bikes Launch in 2020",
            isDisplay: true,
            isActive: false,
        },
        // Add more mock data
    ];

    const totalPages = Math.ceil(data.length / itemsPerPage);

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const modelToggle = (modelname, status, item) => {
        // Get the modal element by ID

        setQuatationItemData(item);
        const modalElement = document.getElementById(modelname);
        let modal = window.bootstrap.Modal.getInstance(modalElement);
        if (!modal) {
            modal = new window.bootstrap.Modal(modalElement);
        }
        // Show or hide the modal based on the status value
        if (status) {
            modal.show(); // Show the modal if status is true
        } else {
            modal.hide(); // Hide the modal if status is false
        }
    };

    const modelToggleData = (modelname, status, item) => {
        setproductOrderData(item)
        const modalElement = document.getElementById(modelname);
        let modal = window.bootstrap.Modal.getInstance(modalElement);
        if (!modal) {
            modal = new window.bootstrap.Modal(modalElement);
        }
        // Show or hide the modal based on the status value
        if (status) {

            // setAppointment(item.quotationId);

            modal.show(); // Show the modal if status is true
        } else {
            modal.hide(); // Hide the modal if status is false
        }
    };

    const handleStatusChange = async (e, item) => {
        const value = e.target.value; // "Accept" | "Reject"
        const statusValue = STATUS_MAP[value]; // Accept=1, Reject=2, Pending=0

        try {
            const response = await post(
                `${endpoints.updateStatusQuatationByUser}?pQuatationId=${item.quotationId}&pStatus=${statusValue}`
            );

            if (response.isSuccess === 200) {
                toast.success("Status updated successfully");
                GetQuatation();
            } else {
                toast.error(response.message || "Failed");
            }
        } catch (error) {
            toast.error("Please try again later");
        }
    };

    return (
        <div className="user_quotation_modal_shadow">
            <AdminLayout>
                <div className="product_wepper">
                    <div className="container-fluid">
                        {/* Table Section */}
                        <div className="row mt-3 product_hedding_table_main">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Name</th>
                                        <th>Email Id</th>
                                        <th>Contact No</th>
                                        <th>Address</th>
                                        <th>Service Type</th>
                                        <th>Size</th>
                                        <th>Price</th>
                                        <th>Product Detail</th>
                                        <th>Referral Source</th>
                                        {/* <th>Additional Msg</th> */}
                                        <th style={{ minWidth: "150px" }}>Queries/Problems</th>
                                        <th>Entry Date</th>
                                        <th>Status</th>
                                        <th>User Status</th>
                                        <th>View</th>
                                        {/* <th>Action</th> */}
                                    </tr>


                                </thead>
                                <tbody>
                                    {quatationData?.length > 0 ? (
                                        quatationData?.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td style={{ minWidth: "150px" }}>{item.firstName} {item.lastName}</td>
                                                <td>{item.emailId}</td>
                                                <td>{item.contactNo}</td>
                                                <td style={{ minWidth: "150px" }}>{item.address} </td>
                                                <td style={{ minWidth: "150px" }}>{item.serviceName}</td>
                                                <td style={{ minWidth: "120px" }}>{item.sizeTypeName}</td>
                                                <td style={{ minWidth: "120px" }}>{item.custom_price > 0 ? item.custom_price : "0" }</td>
                                                <td style={{ minWidth: "120px" }}>{item.productDetail}</td>
                                                <td style={{ minWidth: "150px" }}>{item.referralSource}</td>
                                                {/* <td style={{ minWidth: "120px" }}>{item.additionalMsg}</td> */}
                                                <td style={{ minWidth: "120px" }}>{item?.problems?.map((problem) => problem?.problem_texts).join(", ")}</td>
                                                <td style={{ minWidth: "170px" }}>{item.createdDate}</td>
                                                <td>
                                                    {item?.status !== "" && (
                                                        <button
                                                            className={
                                                                item?.status === "Reject"
                                                                    ? "reject_status_button"
                                                                    : item?.status === "Accept"
                                                                        ? "accept_status_button"
                                                                        : "pending_status_button"
                                                            }
                                                        >
                                                            {item.status}
                                                        </button>
                                                    )}
                                                </td>
                                                <td style={{ minWidth: "150px" }}>
                                                    {item?.user_status !== "Pending" && (
                                                        item?.user_status !== "" && (
                                                            <button
                                                                className={
                                                                    item?.user_status === "Reject"
                                                                        ? "reject_status_button"
                                                                        : item?.user_status === "Accept"
                                                                            ? "accept_status_button"
                                                                            : "pending_status_button"
                                                                }
                                                                disabled={item?.user_status !== "Pending"}
                                                            >
                                                                {item?.user_status}
                                                            </button>
                                                        )
                                                    )}

                                                    {/* DROPDOWN – ONLY IF PENDING */}
                                                    {item?.user_status === "Pending" && (
                                                        <span
                                                            style={{ display: "inline-block", width: "100%" }}
                                                            title={
                                                                item?.status === "Pending"
                                                                    ? "After admin approved quotation, then accept this."
                                                                    : ""
                                                            }
                                                        >
                                                            <select
                                                                className="status_dropdown"
                                                                value=""
                                                                onChange={(e) => handleStatusChange(e, item)}
                                                                disabled={item?.status === "Pending"}
                                                            >
                                                                <option value="" disabled>
                                                                    Select Status
                                                                </option>
                                                                <option value="Accept">Accept</option>
                                                                <option value="Reject">Reject</option>
                                                            </select>
                                                        </span>
                                                    )}
                                                </td>
                                                <td>
                                                    <span className="edit_icon_wepper" onClick={() => modelToggle('modeldata', true, item)} >
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 32 32" fill="none">
                                                            <path d="M16 9.75C12.5537 9.75 9.75 12.5538 9.75 16C9.75 19.4462 12.5537 22.25 16 22.25C19.4463 22.25 22.25 19.4462 22.25 16C22.25 12.5538 19.4463 9.75 16 9.75ZM16 19.75C13.9323 19.75 12.25 18.0677 12.25 16C12.25 13.9323 13.9323 12.25 16 12.25C18.0677 12.25 19.75 13.9323 19.75 16C19.75 18.0677 18.0677 19.75 16 19.75Z" fill="black" />
                                                            <path d="M31.5881 15.3389C30.3622 13.3717 24.1243 4.75 16 4.75C7.8775 4.75 1.63787 13.3716 0.411938 15.3389L0 16L0.411938 16.6611C1.63775 18.6283 7.87569 27.25 16 27.25C24.1225 27.25 30.3621 18.6284 31.5881 16.6611L32 16L31.5881 15.3389ZM16 24.75C9.69775 24.75 4.50862 18.1404 2.99325 15.999C4.50581 13.8559 9.68162 7.25 16 7.25C22.3018 7.25 27.4907 13.8587 29.0068 16.001C27.4942 18.1442 22.3184 24.75 16 24.75Z" fill="black" />
                                                        </svg>
                                                    </span>
                                                </td>
                                                <td>
                                                    {/* <div className="action_btn_weepr">
                                                        <span className="edit_icon_wepper" onClick={() => modelToggleData('modeldatastatus', true, item)} >
                                                            <svg id="Layer_1" viewBox="0 0 512 512" width="15" height="15" xmlns="http://www.w3.org/2000/svg">
                                                                <g transform="matrix(1,0,0,1,0,0)">
                                                                    <path
                                                                        d="m41.3 512c-22.8 0-41.3-18.5-41.3-41.3 0-2.6.2-5.2.7-7.7l27.3-144.8c1.5-8.2 5.5-15.7 11.4-21.5l274-274c14.7-14.7 35.1-22.7 57.7-22.7 8.1 0 16.1 1 24 2.8 25.5 5.9 51.1 20.7 72.2 41.8s36 46.7 41.8 72.2c7.4 31.9.2 61.7-19.8 81.7l-274 274c-5.9 5.9-13.4 9.8-21.5 11.4l-144.8 27.4c-2.5.5-5.1.7-7.7.7zm51.8-93.1 72.9-13.8 182-182-59.1-59.1-182 182zm313.3-254.2 23.1-23.1c.2-5.4-3.8-21.8-20.6-38.5-10.1-10.2-22-17.4-32.4-19.8-1.8-.4-3.7-.7-5.5-.7h-.7l-23 23z"
                                                                        fill="#000"
                                                                    ></path>
                                                                    <path
                                                                        d="m499.4 119.1c-5.4-23.7-19.4-47.6-39.1-67.4s-43.8-33.7-67.4-39.1c-28.5-6.6-54.9-.4-72.3 17.1l-274 274c-4.5 4.4-7.5 10.1-8.7 16.3l-27.4 144.9c-3.2 17 8 33.4 24.9 36.6 1.9.4 3.9.5 5.8.5s3.9-.2 5.8-.5l145-27.4c6.2-1.2 11.9-4.2 16.3-8.6l274-274c17.5-17.5 23.7-43.9 17.1-72.4zm-328.5 295.3-90.3 17 17-90.3 191.3-191.3 73.3 73.3zm267.2-267.2-31.7 31.7-73.2-73.3 31.7-31.7c1-1 5.6-2.3 14-.4 12.2 2.8 25.8 11 37.2 22.4 23.5 23.7 25.6 47.7 22 51.3z"
                                                                        fill="url(#gradient1)"
                                                                    ></path>
                                                                    <defs>
                                                                        <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                                                            <stop offset="0%" stop-color="#000"></stop>
                                                                            <stop offset="100%" stop-color="#000"></stop>
                                                                        </linearGradient>
                                                                    </defs>
                                                                </g>
                                                            </svg>
                                                        </span>
                                                    </div> */}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="14" className="text-center">
                                                No results found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            {/* Pagination */}
                            <nav aria-label="...">
                                <ul className="pagination justify-content-end">
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button className="page-link" onClick={handlePrevPage}>
                                            Previous
                                        </button>
                                    </li>
                                    {Array.from({ length: totalPages }, (_, index) => (
                                        <li
                                            key={index}
                                            className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage(index + 1)}
                                            >
                                                {index + 1}
                                            </button>
                                        </li>
                                    ))}
                                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                        <button className="page-link" onClick={handleNextPage}>
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </AdminLayout>
            {/* Modal */}
            <div className="modal fade" id="modeldata" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="true" data-bs-keyboard="false">
                <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content" style={{ border: "none", overflow: "hidden" }}>
                        <div className="modal-header model_header_bg">
                            <h5 className="modal-title" id="exampleModalLabel" style={{ color: "#ffffff" }}>Quote Information</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">

                            {quatationItemData != null ?

                                <div className="">
                                    <div className="quotation-details row">
                                        <div className="col-sm-6">
                                            <div className="quotation-details-box">
                                                <div className="row">
                                                    <div className="col-md-6" style={{ color: "#3C3C3C" }}><strong>Name :</strong></div>
                                                    <div className="col-md-6" style={{ color: "#626262" }}>{quatationItemData?.firstName} {quatationItemData?.lastName}</div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6" style={{ color: "#3C3C3C" }}><strong>Contact No :</strong></div>
                                                    <div className="col-md-6" style={{ color: "#626262" }}>{quatationItemData?.contactNo}</div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6" style={{ color: "#3C3C3C" }}><strong>Service Type :</strong></div>
                                                    <div className="col-md-6" style={{ color: "#626262" }}>{quatationItemData?.serviceName}</div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6" style={{ color: "#3C3C3C" }}><strong>Product Detail :</strong></div>
                                                    <div className="col-md-6" style={{ color: "#626262" }}>{quatationItemData?.productDetail}</div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6" style={{ color: "#3C3C3C" }}><strong>Additional Message :</strong></div>
                                                    <div className="col-md-6" style={{ color: "#626262" }}>{quatationItemData?.additionalMsg}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="quotation-details-box">
                                                <div className="row">
                                                    <div className="col-md-6" style={{ color: "#3C3C3C" }}><strong>Email Id :</strong></div>
                                                    <div className="col-md-6" style={{ color: "#626262" }}>{quatationItemData?.emailId}</div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6" style={{ color: "#3C3C3C" }}><strong>Address :</strong></div>
                                                    <div className="col-md-6" style={{ color: "#626262" }}>{quatationItemData?.address}</div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6" style={{ color: "#3C3C3C" }}><strong>Size Type Name :</strong></div>
                                                    <div className="col-md-6" style={{ color: "#626262" }}>{quatationItemData?.sizeTypeName}</div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6" style={{ color: "#3C3C3C" }}><strong>Referral Source :</strong></div>
                                                    <div className="col-md-6" style={{ color: "#626262" }}>{quatationItemData?.referralSource}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="quotation-details d-flex gap-4 pt-0">
                                        {quatationItemData?.productPath && (
                                            <div className="">
                                                <p className="mb-2"><strong>Product Image:</strong></p>
                                                <div>
                                                    <img
                                                        src={`${quatationItemData?.productPath}`}
                                                        alt="Product"
                                                        className="quotation-img"
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        {quatationItemData?.serialImagePath && (
                                            <div className="">
                                                <p className="mb-2"><strong>Serial Image:</strong></p>
                                                <div>
                                                    <img
                                                        src={`${quatationItemData?.serialImagePath}`}
                                                        alt="Serial"
                                                        className="quotation-img"
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                : null}
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="modeldatastatus" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Product</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div>
                                <div tyle={{ padding: 20 }}>
                                    {productOrderData != null ? (
                                        <section>
                                            <div>
                                                <div className="container mt-5">
                                                    <header className="d-flex justify-content-between header_weepr">
                                                        <div className="logo">
                                                            <img src="images/logo-white.png" alt="" />
                                                        </div>
                                                        <div className="header_text">
                                                            <h2>QUOTATION</h2>
                                                        </div>
                                                    </header>

                                                    <div className="all_main_wepper">
                                                        <div className="client-details">
                                                            <strong>QUOTATIONTO:</strong>
                                                            <h3>{productOrderData.firstName} {productOrderData.lastName}</h3>
                                                            <p><strong>Phone:</strong>{productOrderData.contactNo}</p>
                                                            <p><strong>Email:</strong>{productOrderData.emailId}</p>
                                                        </div>

                                                        <div className="quotation-details mt-4">
                                                            <p><strong>Dear Client,</strong></p>
                                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
                                                                labore et
                                                                dolore magna aliqua.
                                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
                                                                labore et
                                                                dolore magna aliqua.
                                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
                                                                labore et
                                                                dolore magna aliqua.
                                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
                                                                labore et
                                                                dolore magna aliqua.
                                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
                                                                labore et
                                                                dolore magna aliqua.
                                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
                                                                labore et
                                                                dolore magna aliqua.</p>
                                                        </div>

                                                        <div className="mt-4">
                                                            <table className="product-table" width="100%" cellPadding="8" cellSpacing="0">
                                                                <thead>
                                                                    <tr>
                                                                        <th>S.No.</th>
                                                                        <th>Product Image</th>
                                                                        <th>Product Name</th>
                                                                        <th>Service Name</th>
                                                                        <th>Grade Sqft</th>
                                                                        <th>Price</th>
                                                                    </tr>
                                                                </thead>

                                                                <tbody>
                                                                    <tr>
                                                                        <td>01</td>
                                                                        <td>
                                                                            {productOrderData?.productPath ? (
                                                                                <img
                                                                                    src={`${productOrderData?.productPath}`}
                                                                                    alt="Product"
                                                                                    className="quotation-img"
                                                                                    style={{ maxWidth: "80px", maxHeight: "80px" }}
                                                                                />
                                                                            ) : (
                                                                                <span style={{ color: "#999", fontSize: "12px" }}>
                                                                                    No Image
                                                                                </span>
                                                                            )}
                                                                        </td>
                                                                        <td>{productOrderData.productDetail}</td>
                                                                        <td>{productOrderData.serviceName}</td>
                                                                        <td>{productOrderData.sizeTypeName}</td>
                                                                        <td></td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                        <div className="terms mt-4">
                                                            <div className="terms-conditions-row">
                                                                <div className="left-col">
                                                                    <p><strong>Terms & Conditions:</strong> Lorem ipsum dolor sit amet, consectetur
                                                                        adipiscing
                                                                        elit, sed
                                                                        do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                                                </div>
                                                                <div className="right-col">
                                                                    {/* <p><strong>SUBTOTAL:</strong> ${productOrderItemData.totalAmount}</p> */}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="footer1 text-center mt-4">
                                                            {/* <p><strong>Total: ${productOrderItemData.orderAmount}</strong></p> */}
                                                        </div>

                                                        <div className="signature">
                                                            <p>AUTHORIZED SIGN</p>
                                                        </div>

                                                        <div className="footer1 text-center mt-4">
                                                            <p>For any questions contact us at:</p>
                                                            <p><a href="mailto:Help@sparks-hvac.com">Help@sparks-hvac.com</a></p>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </section>
                                    ) : (
                                        null
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default UserQuotation;
